import request from './request'
// 查询提现渠道
export const getPayChannel = (data) =>
  request({
    url: '/carbon-wallet/private/user/wallet/payment/info/channel',
    method: 'GET',
    params: data,
  })
// 查询钱包可用余额 打码量 以及提现详细信息
export const getMoney = () =>
  request({
    url: `/carbon-wallet/private/user/wallet/payment/info/detail`,
    method: 'GET',
  })
// 获取
export const getPaymentInfoList = () =>
  request({
    url: '/payment_info',
    method: 'GET',
  })
// 生成提现订单
export const withdrawOrder = (data) =>
  request({
    url: '/carbon-wallet/private/user/order/withdrawal',
    method: 'POST',
    data,
  })
// 获取提款背景图
export const getAdvertisingSpaceInfo = (data: any) =>
  request({
    url: '/carbon-misc/public/web/config/withdraw/banner',
    method: 'GET',
    params: data,
  })

//提现取款密码校验
export const checkWithdrawalPassword = (data: any) =>
  request({
    url: '/carbon-wallet/private/user/order/withdrawal/validation',
    method: 'POST',
    data,
  }, {
    skipToast: true,
  })
//提现用户登录密码校验
export const checkWithdrawalLoginPassword = (data: any) =>
  request({
    url: '/carbon-auth/private/user/center/user/validation',
    method: 'POST',
    data,
  })
//设置或者修改提现取款密码
export const setWithdrawalPassword = (data: any) =>
  request({
    url: '/carbon-wallet/private/user/order/withdrawal/password',
    method: 'POST',
    data,
  })

// 获取提款信息
export const getSaqueInfo = () =>
  request({
    url: '/carbon-wallet/private/user/wallet/payment/info/detail',
    method: 'GET'
  })

  //设置或者修改提现取款信息
export const setWithdrawalInfo = (data: any) =>
  request({
    url: '/carbon-wallet/private/user/wallet/payment/info/edit',
    method: 'POST',
    data,
  })
// 获取普通充值配置
export const getRechargeConfig = () =>
  request({
    url: '/carbon-wallet/private/user/order/recharge/list/config',
    method: 'GET',
  })